import { withStyles } from '@mui/styles';
import MuiTableCell from "@mui/material/TableCell";
import useBSSLogger from '../hooks/useBSSLogger';
import { makeStyles } from '@mui/styles';

const {logger} = useBSSLogger();

const OptionTableCell = withStyles({
    root: {
        borderBottom: "none"
    }
})(MuiTableCell);

/**
 * 
 * @param {import('@mui/material').Theme} theme 
 * @returns 
 */
const themeMaker = (theme) => {

    return {
        label: {
            fontWeight: 'bold',
            color: "black"
        },
        container: {
            paddingTop: theme.spacing(1),
        },
        formGroupBox: {
            padding: theme.spacing(1),
        }, 
        noRightRadius: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
        noLeftRadius: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },        

    }
}

const bssMakeStyles = makeStyles(themeMaker);

const NumberComparators = { 
    lte: (a, b) => a <= b,
    lt: (a, b) => a < b,
    gte: (a, b) => a >= b,
    gt: (a, b) => a > b,
    eq: (a, b) => a === b,
    ne: (a, b) => a !== b
}

const sortedBreakpoints = theme => theme.breakpoints.keys
    .sort((keya, keyb) => theme.breakpoints.values[keya] - theme.breakpoints.values[keyb])
    .reduce((obj, key, index) => ({...obj, [k]: theme.breakpoints.values[key]}), {})

/**
 * 
 * @param {{ currBreakpoint: ("xs"|"sm"|"md"|"lg"|"xl"), compareToBreakpoint: ("xs"|"sm"|"md"|"lg"|"xl"), operator: ("lt"|"lte"|"gte"|"gt"|"eq"|"ne"), theme: import('@mui/material').Theme}} param0 
 * @returns 
 */
const breakpointComparator = ({currBreakpoint, compareToBreakpoint, operator, theme}) => 
    NumberComparators[operator](theme.breakpoints.values[currBreakpoint], theme.breakpoints.values[compareToBreakpoint])

/** 
 * @param {Number} width 
 * @returns {String} xs|sm|md|lg|xl
 */
const width2Breakpoint = (width, theme) => theme.breakpoints.keys.reduce((obj, bpk, index, allkeys) => {
    const nextkey = allkeys[index+1];
    if(nextkey !== undefined){
        const maxw = theme.breakpoints.values[allkeys[index+1]];
        const currdiff = maxw - width;
        if(currdiff > 0 && currdiff < obj.diff){
            obj.key = bpk;
            obj.diff = currdiff;
        }        
        logger.all(width, bpk, maxw, currdiff, obj.diff)
    }
    
    return obj;
}, {key: 'xs', diff: Infinity}).key; 


export default themeMaker;
export {OptionTableCell, width2Breakpoint, breakpointComparator, bssMakeStyles}